import React from 'react';
import TableRow from "../UI/table/TableRow";
import useAsync from "../../utilities/customHooks/async-call";
import {useRegistry} from "../../utilities/contexts/registry-context";
import {doGetSupplier} from "../../logics/registry";
import {FaTrashAlt, FaPencilAlt} from "react-icons/fa";

const SupplierRow = ({supplier, onDelete, ...props}) => {

    const {setCurrentSupplier, setRegistryPanelOpen} = useRegistry();
    const {call} = useAsync();

    const handleDelete = async (event) => {
        event.stopPropagation();
        onDelete && onDelete(supplier.idforn)
    }

    const handleClick = async () => {
        await call(
            () => doGetSupplier(supplier.idforn),
            (res) => {
                if (res && res[0]) {
                    setCurrentSupplier(res[0]);
                    setRegistryPanelOpen(true);
                }
            }
        )
    }

    const handleEditClick = (event) => {
        event.stopPropagation();
        handleClick();
    }

    return (
        <TableRow onClick={handleClick} className='text-sm mb-0.5'>
            <td className="pl-2">
                {supplier.ragsocf}
            </td>
            <td className="pl-2">
                {supplier.contatto}
            </td>
            <td>
                <div className="w-full flex flex-row items-center justify-center gap-2">
                    <FaPencilAlt
                        title="Modifica"
                        onClick={handleEditClick}
                        className="cursor-pointer hover:text-blue-500"/>
                    <FaTrashAlt
                        title="Cancella fornitore"
                        onClick={handleDelete}
                        className="cursor-pointer hover:text-red-500"/>
                </div>
            </td>
        </TableRow>
    )
}

export default SupplierRow;
